import { gsap } from "gsap";

const duration = 0 // in seconds

export default {
	name: 'fade',
	sync: false,
	beforeLeave(data) {
		return gsap.set(data.current.container, {
			css: { position: 'absolute' }
		});
	},
	leave(data) {
		return gsap.to(data.current.container, {
			opacity: 0,
			duration: duration
		});
	},
	enter(data) {
		console.log('fade enter')
		return gsap.from(data.next.container, {
			opacity: 0,
			duration: duration
		});
	}
}
